import React, { FC } from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";
import { px } from "Configs/theme";
import FadeInBox from "Components/Layout/FadeInBox";

const LoadingIndicator: FC = () => {
  const classes = useStyles();

  return (
    <FadeInBox className={classes.box} delay={800} delayIndex={1}>
      <CircularProgress />
    </FadeInBox>
  );
};

export default LoadingIndicator;

const useStyles = makeStyles({
  box: {
    padding: px.m,
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});
